<template>
    <div class="m-auto text-center">
        <v-icon :class="{'pt-12 mt-sm-12 pb-5':!noPadding}" :color="textColor" :style="`font-size: ${fontSize}px;`">{{icon}}</v-icon><!-- mdi-alert-decagram-->
        <h2 :style="{'color':textColor}"><slot>{{text}}</slot></h2>
        <p :style="{'color':textColor}"><slot name="subTitle"></slot></p>
    </div>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
    export default {
        mixins: [layoutMixin],
        props:{
            icon:{
                type:String,
                default:'mdi-alert'
            },
            text:{
                type:String,
                default:'Oha. Jetzt ist gerade etwas schief gelaufen.'
            },
            iconColor:{
                type:String,
                default:'grey darken-2'
            },
            isMobile:{
                type:Boolean,
                default:false,
            },
            noPadding:{
                type:Boolean,
                default:false,
            },
            // icon and text color; falls back to the event text color
            color:{
                type:String,
                default:null
            }
        },
        computed:{
            fontSize(){
                return this.isMobile?70:120;
            },
            textColor(){
                return this.color || this.theme.textColor;
            }
        }
    }
</script>